import React, {Fragment} from 'react';
import {Link} from 'react-router-dom';
import {connect} from 'react-redux';
import moment from 'moment';
import {bindActionCreators} from "redux";

import {deleteArticle, updateArticle} from "../../creators/article";
import {deleteStory} from "../../creators/story";

import Views from './Views';
import Avatar from './Avatar';
import Answers from './Answers';
import Dropdown from './Dropdown';
import Alert from './Alert';
import Icon from './Icon';
import TagList from './TagList';
import Report from './Report';
import {Button} from "./Button";
import Title from "./Title";
import {Can} from "../../ability-context";
import Modal from "./Modal";
import DateSince from "./Date";
import createLink from "../../libs/createLink";
import Like from "./Like/Like";
import DraftContentReader from "./editor/DraftContentReader";
import {PageLoader} from "./Loader";
import Helmet from "react-helmet";
import {config} from "../../config";
import LikeBtn from "./Like/LikeBtn";
import {isNoFollowArticle, isNoFollowProfil} from "../../libs/helper";
import _ from "lodash";

class ArticleCard extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            toggleAlertDeleteArticle: false,
        };
        this.editorRef = React.createRef();

        this.isPublishedLater = false;
        this.handleDelete = this.handleDelete.bind(this);

        let datePublisher = moment(this.props.publishedAt ? this.props.publishedAt : "").format("YYYY-MM-DD HH:mm");
        this.isPublishedLater = moment().diff(datePublisher, 'secondes') <= 0;
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(prevProps.contentRaw !== this.props.contentRaw){
            this.editorRef.current.updateContent(this.props.contentRaw);
        }
    }

    handleDelete() {
        this.props.handleDelete();
    }

    render() {
        let title = this.props.title || " ";
        title = title.charAt(0).toUpperCase() + title.substring(1).toLowerCase();
        let hasOwner = this.props.owner !== null && this.props.owner._id;
        let relLinkProfil = isNoFollowProfil(this.props.owner) ? { rel: "nofollow" } : {};

        return (
            <article className="card-article mt-16">
                <Helmet>
                    <title>{config.preTitle}{this.props.title}{config.postTitle}</title>
                    {isNoFollowArticle(this.props) ? <meta name="robots" content="noindex" /> : null}
                </Helmet>
                <div className="container">
                    <div className="btn-group justify-space-between back-button pt-8">
                        {/*<span className="article-blog-location">Blog : <Link*/}
                        {/*to={`/blog/${this.props.blog._id}-${this.props.blog.slug}`}>{this.props.blog.title}</Link></span>*/}
                        <span />
                        {this.props.fromStories && this.props.type !== "article-preview" ? (
                            <Button className={"back"}
                                    size={"small"}
                                    to={createLink('stories')}
                                    // onClick={() => history.push(this.redirectTo())}
                                    btnStyle={"primary-reverse"}
                                    content={"Retour aux histoires"}/>
                        ) : this.props.fromProfile && this.props.type !== "article-preview" && hasOwner ? (
                            <Button className={"back"}
                                    size={"small"}
                                    to={createLink("userArticles", {slug: this.props.owner.slug})}
                                    btnStyle={"primary-reverse"}
                                    content={"Retour aux articles du profil"}/>
                        ) : this.props.type !== "article-preview" && (
                            <Button className={"back"}
                                    size={"small"}
                                    to={createLink("articles")}
                                    btnStyle={"primary-reverse"}
                                    content={"Retour aux articles"}/>
                        )}
                    </div>
                    <div className="wrapper-title-card-article column">
                        <div
                            className={`column full card-title-container py-16 px-8 ${this.isPublishedLater ? 'published-later' : ''} ${!this.props.status || !this.props.isOpened ? 'draft' : ''}`}>
                            {this.isPublishedLater && <div className="badge blue my-8">Sera publié le
                                : <DateSince
                                    date={this.props.publishedAt}
                                    prefix={false}
                                    currentFormat={false}
                                /></div>}
                            {!this.props.status && <div className="badge closed my-8">Brouillon</div>}
                            {!this.props.isOpened && (
                                <div className="badge closed my-8">Article fermé</div>
                            )}
                            {hasOwner ? (
                                <Link to={createLink("userProfile", this.props.owner)}
                                      {...relLinkProfil}
                                      className="mb-16 avatar-container">
                                    <Avatar className="thumb-user"
                                            width={70}
                                            height={70}
                                            avatar={this.props.owner.profile.avatar || this.props.avatar}
                                            gender={this.props.owner.profile.gender || this.props.gender} alt=""/>
                                </Link>
                            ) : (
                                <Avatar className="thumb-user" gender={"guest"} width={150}
                                        height={150}/>
                            )}
                            <div className="column full align-center">
                                <Title heading={"heading-1"} display={"display-1"}>
                                    {title}
                                </Title>
                                <div className="wrapper-infos-user">
                                    Par&nbsp;
                                    {hasOwner ? (
                                        <Link to={createLink("userProfile", this.props.owner)}
                                              {...relLinkProfil}
                                              className="profil-link">
                                            <div className="username">{this.props.owner.username}</div>
                                        </Link>
                                    ) : (
                                        <div className="username">{this.props.authorName}</div>
                                    )},&nbsp;
                                    <div className="date">
                                        <DateSince
                                            date={this.props.publishedAt}
                                            prefix={false}
                                            currentFormat={true}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <Can action={"moderation"} subject={this.props} modelName={"Article"}>
                            <div className="right-btn-group pt-24 wrap full">
                                <Dropdown align="right" activableComponent={(
                                    <Button className={"article-btn my-4"}
                                            size={"small"}
                                            btnStyle={"cancel-reverse"}
                                            content={"Gestion de l'article"}/>
                                )}>
                                    <ul className="dropdown-menu">
                                        <Can action={"delete"} subject={this.props} modelName={"Article"}>
                                            <li className="menu-item"
                                                onClick={() => this.setState({toggleAlertDeleteArticle: true})}><Icon
                                                type="close"/> Supprimer
                                            </li>
                                        </Can>
                                        <Can action={"update"} subject={this.props} modelName={"Article"}>
                                            <li className="menu-item" onClick={() => this.props.handleOpenAdvancedEditor()}>
                                                <Icon type="pencil"/>Editer
                                            </li>
                                        </Can>
                                        <Can action={"close"} subject={this.props} modelName={"Article"}>
                                            <li className="menu-item" onClick={()=>this.props.handleStatus("isOpened", !this.props.isOpened)}>
                                                {this.props.isOpened ? (
                                                    <Fragment>
                                                        <Icon type="lock"/> Fermer
                                                    </Fragment>
                                                ) : (
                                                    <Fragment>
                                                        <Icon type="unlock"/> Ouvert
                                                    </Fragment>
                                                )}
                                            </li>
                                        </Can>
                                    </ul>
                                </Dropdown>
                            </div>
                        </Can>
                        <Modal toggle={this.state.toggleAlertDeleteArticle}
                               handleClose={() => this.setState({toggleAlertDeleteArticle: false})}>
                            <Alert text="Voulez-vous vraiment supprimer cet article ?" handleDelete={this.handleDelete}
                                   handleClose={() => this.setState({toggleAlertDeleteArticle: false})}/>
                        </Modal>
                        <div className="wrapper-text-article full">
                            {this.props.cover && this.props.cover.length >= 1 && (
                                <img alt="" src={`${this.props.cover}?width=740`} className="mb-8" loading="lazy"/>
                            )}
                            {this.props.isLoading ? <PageLoader/> : (
                                <DraftContentReader contentRaw={this.props.contentRaw} ref={this.editorRef}/>
                            )}
                        </div>
                    </div>
                    <div className="article-stats column full my-16">
                        <TagList tags={this.props.tags} type={"tagArticle"} owner={this.props.owner}/>
                        <div className="article-stats-wrapper row justify-center mt-32">
                            <div className="column">
                                <div className="row text medium dark bold mb-16">Avez vous aimé cet article ?</div>
                                    <LikeBtn isLiked={this.props.isLiked}
                                             value={_.get(this.props,"count.like") || 0}
                                             parentId={this.props._id}
                                             likeType={this.props.likeType}/>
                                <div
                                    className="row stats my-16 flex-1 align-center justify-center text medium medium-grey">
                                    <Like
                                        isLiked={this.props.isLiked}
                                        value={_.get(this.props,"count.like") || 0}
                                        likeType={this.props.likeType}
                                        parentId={this.props._id}
                                    />
                                    {this.props.currentUserInitialized && ("·")}
                                    <Views type="icon" value={_.get(this.props,"count.view") || 0}/> ·
                                    <Answers value={this.props.count.comment || 0}/>
                                </div>
                            </div>
                            <Can action={"report"} subject={this.props} modelName={"Article"}>
                                <Report _id={this.props._id}
                                        handleReport={this.props.handleReport}
                                        kind={"articles"}
                                        type={"button"}
                                        title={this.props.title}/>
                            </Can>
                        </div>
                    </div>
                </div>
            </article>
        )
    }
}

ArticleCard.defaultProps = {
    title: "",
    slug: '',
    content: '',
    owner: {
        slug: '',
        username: '',
        profile: {
            avatar: "",
            gender: ""
        }
    }
};

const mapStateToProps = (state) => {
    return {
        currentUserLoading: state.currentUser.loading,
        currentUserInitialized: state.currentUser.initialized
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    deleteStory,
    updateArticle,
    deleteArticle
}, dispatch);


export default connect(mapStateToProps, mapDispatchToProps)(ArticleCard);
